module.exports = __webpack_public_path__ + "media/images/pic/communication_green-e82f5366c5753c499693fd7a4749dc7c.svg";